export default "__VITE_ASSET__CQR8wJF2__"